<template>
    <div>
        <div class="box"></div>
        <div class="box2">
            <div class="lef">
                <div>安全教育培训</div>
                <p  @click="$router.push('safety1')">· 安全教育魔盒</p>
                <p class="don" @click="$router.push('safety2')">· 安全教育一体机</p>
                <p @click="$router.push('safety3')">· 九象培训箱</p>
                <p @click="$router.push('safety4')">· VR安全体验馆</p>
            </div>
            <div class="rit">
                <p class="tit">安全教育一体机</p>
                <div class="img2">
                    <img src="../../assets/images/progd/safety/ytj.jpg" style="width: 7rem; height: 3.94rem">
                </div>
                <div class="txt">
                    <strong>安装便捷</strong><br>
                    播控显示一体，通电播放，32寸超清显示，无需插线。无线2.4GHz遥控，百平米遥控范围，全方位掌控。<br><br>
                    <strong>内容丰富</strong><br>
                    全3D动画特效制作安全事故警示片，全过程事故案例及处理模拟，多模式全能循环播放，全方位展示定制服务。持续提供软硬件设备更新与内容更新服支持。<br><br>
                    <strong>设备参数</strong>
                </div>
                <div class="img2" style="margin-top:.22rem">
                    <img src="../../assets/images/progd/safety/yt2.jpg" style="width: 7.64rem; height: 2.07rem;">
                </div>
                <div class="but">
                    <span class="l" @click="pageClick(1)">上一篇</span>
                    <span class="r" @click="pageClick(3)">下一篇</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Safety2",
        methods:{
            pageClick(evn) {
                this.$router.push('safety'+evn);
                document.documentElement.scrollTop=0;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .box{
        height: 2.9rem;
        width: 100%;
        background: url("../../assets/images/aq.jpg");
        background-size: 100% 100%;
    }
    .box2{
        width: 12rem;
        margin:.6rem auto 0;
        display: flex;
        .lef{
            width: 1.76rem;
            overflow: hidden;
            div{
                font-size: .2rem;
                position: relative;
                padding-left: .1rem;
                margin-bottom:.19rem;
            }
            div::before{
                position: absolute;
                content: "";
                left:0rem;
                top:.06rem;
                background: #E70F20;
                width: 2px;
                height: .16rem;
            }
            p{
                line-height: .34rem;
                font-size: .16rem;
                width: 1.76rem;
                color:#3F3F3F;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                cursor: pointer;
            }
            .don{
                color:#E70F20
            }
        }
        .rit{
            margin-left: .15rem;
            padding-left:.8rem;
            border-left: 1px solid #E5E5E5;
            width: 10.07rem;
            p.tit{
                width: 5.7rem;
                font-size: .26rem;
                text-align: center;
                margin: 0 auto;
                line-height: .41rem;
                letter-spacing: 1px;
            }
            div.txt{
                margin-top:.44rem;
                line-height: .36rem;
                color:#595757;

                font-size: .18rem;
                text-align: justify;
            }
            div.img2{
                text-align: center;
                margin-top:.47rem;
            }
            div.but{
                text-align: center;
                margin-top:.56rem;
                span{
                    width: 69px;
                    height: 26px;
                    line-height: 29px;
                    display: inline-block;
                    font-size: 12px;
                    margin:0 .25rem;
                    cursor: pointer;
                }
                .l{
                    background: url("../../assets/images/pg.png");
                    background-size: 100% 100%;
                    padding-left:.07rem
                }
                .r{
                    background: url("../../assets/images/pg2.png");
                    background-size: 100% 100%;
                    padding-right:.07rem
                }
            }
        }
    }
</style>